import { fuseAnimations } from './../../../@fuse/animations/index';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
    selector: 'fb-annotazioni',
    templateUrl: './annotazioni.component.html',
    styleUrls: ['./annotazioni.component.scss'],
    animations: fuseAnimations,
})
export class AnnotazioniComponent implements OnInit, OnDestroy {
    editingAnnotazioni: boolean = false;
    annotazioniFormControl = new FormControl('');

    private unsubscribeAll = new Subject<void>();
    private _annotazioni: string;

    @Input()
    set annotazioni(value: string) {
        this._annotazioni = value;
        this.annotazioniFormControl.setValue(value);
    }

    @Output()
    salvaAnnotazioniEvent = new EventEmitter<string>();

    get annotazioni() {
        return this._annotazioni;
    }

    constructor() {}

    ngOnInit(): void {}

    onSalvaAnnotazioni() {
        this.salvaAnnotazioniEvent.emit(this.annotazioniFormControl.value);
        this.editingAnnotazioni = false;
        this.annotazioniFormControl.reset(this.annotazioni);
    }

    onAnnullaAnnotazioni() {
        this.editingAnnotazioni = false;
        this.annotazioniFormControl.reset(this.annotazioni);
    }

    ngOnDestroy(): void {
        this.unsubscribeAll.next();
        this.unsubscribeAll.complete();
    }
}
